<ng-container *hasPermission="['TS_UPLOADED_FILE_CREATE','TS_UPLOADED_FILE_ALL']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Caricamento file</h2>
        </div>
        <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
                <div class="col-md-6">
                    <label for="name" class="form-label">Servizi attivi</label>
                    <select class="form-select" aria-label="Tipo" id="type" name="type" [(ngModel)]="cameraServiceId" 
                        required>
                        <option selected value=""></option>
                        <option *ngFor="let cameraService of cameraServices" [value]="cameraService.id">
                            {{cameraService.name}}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label for="uploadFile" class="form-label">Caricamento file (zip)</label>
                    <input class="form-control form-control-sm" type="file" accept=".zip" id="uploadFile"
                        name="uploadFile" (change)="handleDocumentFileInput($event)" required
                        [ngClass]="uploadFile? 'ng-dirty ng-valid ng-touched': 'ng-invalid'">
                </div>
            </div>
            <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                <button *hasPermission="['TS_UPLOADED_FILE_CREATE','TS_UPLOADED_FILE_ALL']" type="submit"
                    class="btn btn-primary">Carica</button>
            </div>
        </form>
       
    </div>

</ng-container>